export enum QuarterDatePeriodEnum {
	Quarter1 = 'Quarter 1',
	Quarter2 = 'Quarter 2',
	Quarter3 = 'Quarter 3',
	Quarter4 = 'Quarter 4',
}
